import { isFedRamp } from '@atlassian/atl-context';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

export const useAIRovoButtonEnablement = () => {
	const { isAdminHubAIEnabled, isRovoLLMEnabled } = useSessionData();
	return !isFedRamp() && isAdminHubAIEnabled && isRovoLLMEnabled;
};
